/** @jsx jsx */
import { node } from 'prop-types'
import { Flex, jsx } from 'theme-ui'

const DashboardTemplate = ({ children }) => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        pt: [6, 6, 80],
        px: 5,
        pb: 80,
        bg: 'white',
      }}
    >
      <Flex sx={{ flexDirection: 'column', maxWidth: 1156, width: '100%' }}>
        {children}
      </Flex>
    </Flex>
  )
}

DashboardTemplate.propTypes = {
  children: node.isRequired,
}
export default DashboardTemplate
